// extracted by mini-css-extract-plugin
export default {"containprod":"tF","containprod2":"uF","title":"vF","servings":"wF","recommendation":"xF","image":"yF","flavorswrap":"zF","flavorsgroupwrap":"AF","moredetailsWrap":"BF","infoWrap":"CF","price":"EF","regularPrice":"FF","netPrice":"GF","addtocartcontainer":"HF","error":"IF"};
    if(module.hot) {
      // 1713996747629
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  